// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__gw-Ar"};